"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterEvent = void 0;
const abi_1 = require("@ethersproject/abi");
const filterEvent = (event, eventName, txResponse) => {
    if (txResponse.logs === undefined) {
        throw new Error('no events');
    }
    const iface = new abi_1.Interface([event]);
    const eventLog = txResponse.logs.find(e => {
        try {
            return iface.parseLog(e).name === eventName;
        }
        catch (_) {
            return false;
        }
    });
    if (!eventLog) {
        throw new Error(`${eventName} not found in transaction`);
    }
    return iface.parseLog(eventLog);
};
exports.filterEvent = filterEvent;
//# sourceMappingURL=filterEvent.js.map